import { createElement } from 'react';
import { Input } from '@alifd/next';
import './index.scss';
const OadpAttributeText = function OadpAttributeText({ name, label, required, placeholder, defaultValue, disabled, ...otherProps }) {
    return (createElement(Input, Object.assign({ name: name, label: label, placeholder: placeholder, defaultValue: defaultValue, required: required, disabled: disabled, hasClear: true, trim: true }, otherProps)));
};
export default OadpAttributeText;
